import Dot from '@components/Dot';
import { Blue, Red } from '@constants/color';
import { FC } from 'react';

import * as styles from './styles';

interface StatusPanelProps {
  untactOnTreatment: boolean;
}

const StatusPanel: FC<StatusPanelProps> = ({ untactOnTreatment }) => {
  return (
    <div css={[styles.status, untactOnTreatment && styles.unavailable]}>
      <Dot color={untactOnTreatment ? Blue.Blue50 : Red.Red60} />{' '}
      {untactOnTreatment ? '진료가능' : '진료불가능'}
    </div>
  );
};

export default StatusPanel;
